import { useMemo } from 'react';
import Container from '@/src/components/ui/container';
import { ThemeLayout } from './ThemeLayout';
import Typography from '@/src/components/ui/typography';
import { ICmsBranch, ICmsTheme } from '../services/types';
import { SliderLayout } from '@/src/components/Layout/SliderLayout';
import CmsStoreCard from './CmsStoreCard';

type Props = {
  theme: ICmsTheme;
  name: string;
  stores: ICmsBranch[];
};

const PROMOTED_ITEMS_CLASS = 'lg:basis-[22%] md:basis-[26%] basis-[45%] md:pl-4 pl-2';
const DEFAULT_ITEMS_CLASS = 'lg:basis-[12%] md:basis-[16%] basis-[32%] md:pl-4 pl-2';
const CONTAINER_CLASS = 'lg:ps-6 ps-3';

export const PromotedStores = ({ theme, name, stores }: Props) => {
  const isAllHaveTheme = useMemo(() => stores.every((item) => item.store?.theme != null), [stores]);

  const hasStores = stores.length > 0;
  const firstStoreId = useMemo(() => stores[0]?.id.toString(), [stores]);

  if (!hasStores || !firstStoreId) {
    return null;
  }

  const itemsClassName = isAllHaveTheme ? PROMOTED_ITEMS_CLASS : DEFAULT_ITEMS_CLASS;

  return (
    <Container>
      <ThemeLayout
        id={firstStoreId}
        theme={theme}
        alt="trading Stores"
        header={
          <Typography
            variant="h4"
            component={'h2'}
            weight={'semibold'}
            align="start"
            className="text-inherit"
          >
            {name}
          </Typography>
        }
      >
        <SliderLayout itemsClassName={itemsClassName} conatinerClassName={CONTAINER_CLASS}>
          {stores.map((store) => (
            <CmsStoreCard key={store.id} store={store} isPromoted={isAllHaveTheme} />
          ))}
        </SliderLayout>
      </ThemeLayout>
    </Container>
  );
};
